import { MutationTree } from 'vuex';
import { IGlobalTemplate } from '../types/global-template';
import { ITemplateGalleryState } from '../types/template-gallery-state';
import { ETemplateGalleryMutation } from './template-gallery.constants';

export const mutations: MutationTree<ITemplateGalleryState> = {
  [ETemplateGalleryMutation.SetLoading](state: ITemplateGalleryState, loading: boolean) {
    state.loading = loading;
  },
  [ETemplateGalleryMutation.SetLoaded](state: ITemplateGalleryState, loaded: boolean) {
    state.loaded = loaded;
  },
  [ETemplateGalleryMutation.SetTemplates](
    state: ITemplateGalleryState,
    templates: IGlobalTemplate[]
  ) {
    state.templates = templates;
  },
  [ETemplateGalleryMutation.SetDocumentId](state: ITemplateGalleryState, documentId: string) {
    state.documentId = documentId;
  },
  [ETemplateGalleryMutation.SetNewTemplateId](state: ITemplateGalleryState, newTemplateId: string) {
    state.newTemplateId = newTemplateId;
  },
};
